/*
Readme:
Please specify the following when implementing
 * relay ref, e.g. <button ref="relay">..</button>
 * hold modal e.g. <b-modal ref="hold-modal">..</b-modal>

*/

import { Component, Vue, Prop } from 'vue-property-decorator';
import { IRelay } from '../store/views/relaysView/types';
import { RelaysState, IRelayState } from '../store/relays/types';
import { State, Getter, Action, Mutation } from 'vuex-class';


@Component({ })
export default class RelayMixin extends Vue {

    public deviceNumber: string;
    public relay: IRelay | null = null;


    @Prop({default: false})
    public isEditing?: boolean;


    @Getter('relays/locked')
    public locked: boolean;

    public get areRelaysLoaded(): boolean {
        return this.areRelaysLoadedGetter && this.areRelaysLoadedGetter(this.deviceNumber)
            ? true
            : false;
    }

    @Getter('relays/getRelayState')
    private getRelayState?: (deviceNumber: string, relayNo: number) => IRelayState;

    @Getter('relays/areRelaysLoaded')
    private areRelaysLoadedGetter?: (deviceNumber: string) => boolean;


    @Action('relays/toggle')
    private relayToggle: (args: { deviceNumber: string, relayNumber: number, duration?: number})
        => Promise<any>;

    @Action('relays/turnOn')
    private relayTurnOn: (args: { deviceNumber: string, relayNumber: number, turnOfAfterMs?: number})
        => Promise<any>;

    @Action('relays/holdOn')
    private relayHoldOn: (args: { deviceNumber: string, relayNumber: number}) => Promise<any>;
    @Action('relays/holdOff')
    private relayHoldOff: (args: { deviceNumber: string, relayNumber: number}) => Promise<any>;

    @Action('relays/unlock')
    private relayUnlock: () => Promise<any>;

    private isMouseDown: boolean = false;
    private hasTouch: boolean = false;


    public get lockable(): boolean {
        return this.relay && this.relay.mode === 'hold' || false;
    }
    public get relayState(): IRelayState {
        return this.deviceNumber && this.relay && this.getRelayState
            && this.getRelayState(this.deviceNumber, this.relay.no)
            || { isOn: false, isLoading: true };
    }

    public setRelayInfo(deviceNumber: string, relay: IRelay) {
        this.deviceNumber = deviceNumber;
        this.relay = relay;
        this.$store.dispatch('relays/load', { deviceNumber: this.deviceNumber });
    }

    public mounted() {
        const element = this.$refs.relay as HTMLElement || this.$el;
        element.addEventListener('mousedown', (e) => this.relayMouseDown(e as MouseEvent), {passive: true});
        element.addEventListener('touchstart', (e) => this.relayTouchstart(e as TouchEvent), {passive: true});
        element.addEventListener('click', (e) => this.click(e as MouseEvent), {passive: true});
        document.addEventListener('mouseup', (e) => this.relayMouseUp(e as MouseEvent), {passive: true});
        document.addEventListener('touchend', (e) => this.relayTouchEnd(e as TouchEvent), {passive: true});
        document.addEventListener('touchcancel', (e) => this.relayTouchEnd(e as TouchEvent), {passive: true});
    }

    public beforeDestroy() {
        const element = this.$refs.relay as HTMLElement || this.$el;
        element.removeEventListener('mousedown', (e) => this.relayMouseDown(e as MouseEvent));
        element.removeEventListener('touchstart', (e) => this.relayTouchstart(e as TouchEvent));
        document.removeEventListener('mouseup', (e) => this.relayMouseUp(e as MouseEvent));
        document.removeEventListener('touchend', (e) => this.relayTouchEnd(e as TouchEvent));
        document.removeEventListener('touchcancel', (e) => this.relayTouchEnd(e as TouchEvent));
    }

    public unlock() {
        this.relayUnlock();
    }


    private click(evt: MouseEvent): void {
        if (this.deviceNumber && this.relay && !this.isEditing && (this.relay.mode || '') === '') {
            this.relayToggle({
                deviceNumber: this.deviceNumber,
                relayNumber: this.relay.no,
            });
        }
    }
    private relayMouseDown(evt: MouseEvent): void {
        if (!this.hasTouch) {
            if (!this.isMouseDown) {
                this.startSending();
            }
            this.isMouseDown = true;
        }
    }
    private relayMouseUp(evt: MouseEvent): void {
        if (!this.hasTouch) {
            if (this.isMouseDown) {
                this.stopSending();
            }
            this.isMouseDown = false;
        }
    }
    private relayTouchstart(evt: TouchEvent): void {
        this.hasTouch = true;
        if (!this.isMouseDown) {
            this.startSending();
        }
        this.isMouseDown = true;
    }
    private relayTouchEnd(evt: TouchEvent): void {
        this.hasTouch = true;
        if (this.isMouseDown) {
            this.stopSending();
        }
        this.isMouseDown = false;
    }

    private startSending(): void {
        if (this.deviceNumber && this.relay && !this.isEditing) {
            switch (this.relay.mode || '') {
                case '1sec':
                        this.relayTurnOn({
                            deviceNumber: this.deviceNumber,
                            relayNumber: this.relay.no,
                            turnOfAfterMs: 1000,
                        });
                        break;
                case 'hold':
                    if (this.locked) {
                        (this.$refs['hold-modal'] as any).show();
                    } else {
                        this.relayHoldOn({
                            deviceNumber: this.deviceNumber,
                            relayNumber: this.relay.no,
                        });
                    }
                    break;
                default:

                    break;
            }
        }
    }
    private stopSending(): void {
        if (this.relay && this.relay.mode === 'hold' && this.deviceNumber && !this.locked) {
            this.relayHoldOff({
                deviceNumber: this.deviceNumber,
                relayNumber: this.relay.no,
            });
}
    }
}
